import Util from "./../lib/util";
import Repository from "./Repository";
import jsonRepository from "./JsonRepository";
import logger from "../lib/logger";
/* #74 簡易カメラの表示 ローカルファイルを参照しないよう一時的コメント化および代替処理の追加 */
//import axios from "axios";

const resource = "";
const timeFormat = "YYYY-MM-DD HH:mm";

export default {
  /**
   * 登録地点テレメータ一覧取得
   * @param minlat 左下緯度
   * @param maxlat 右上経度
   * @param minlon 左下経度
   * @param maxlon 右上緯度
   */
  getTmPointDatas(minlat, maxlat, minlon, maxlon) {
    let param = "/" + minlat + "," + maxlat + "," + minlon + "," + maxlon;
    return Repository.get(`${resource}/tmPointList` + param);
  },

  /**
   * 破堤点からの周辺観測所一覧取得
   * @param {*} minLat 最小緯度リスト
   * @param {*} minLon 最小経度リスト
   * @param {*} maxLat 最大緯度リスト
   * @param {*} maxLon 最大経度リスト
   * @param {*} rvrCd 河川コードリスト
   */
  getTmPointDatasBp(minLat, minLon, maxLat, maxLon, rvrCd) {
    let param =
      "/" + minLat + "/" + minLon + "/" + maxLat + "/" + maxLon + "/" + rvrCd;
    return Repository.get(`${resource}/tmPointListBp` + param);
  },
  /**
   * 地点登録の周辺観測所の情報を取得
   * @param ofcCd 管理事務所番号
   * @param itmkndCd 観測所種別コード
   * @param obsCd 観測所コード
   */
  getTmPointData(ofcCd, itmkndCd, obsCd) {
    let param = "/" + ofcCd + "/" + itmkndCd + "/" + obsCd;
    return Repository.get(`${resource}tmPoint` + param);
  },

  /**
   * 地点登録の周辺CCTVの情報を取得
   * @param {*} ofcCd 管理事務所番号
   * @param {*} cctvCd 河川カメラID
   */
  getTmPointCctvData(ofcCd, cctvCd) {
    let param = "/" + ofcCd + "/" + cctvCd;
    return Repository.get(`${resource}cctvPoint` + param);
  },

  /**
   * 地点登録の観測所の対象日時情報を取得
   * @param {*} ofcCdList 管理事務所番号
   * @param {*} itmkndCdList 観測所種別コード
   * @param {*} obsCdList 観測所コード
   */
  getTmPointIndivData(payload) {
    let param =
      "/" +
      payload.ofcCdList +
      "/" +
      payload.itmkndCdList +
      "/" +
      payload.obsCdList +
      "/" +
      payload.appTime +
      "/" +
      payload.isCurrent;
    return Repository.get(`${resource}tmPointIndivData` + param);
  },

  /**
   * 選択中テレメータ情報 取得
   * @param {object} payload
   * @property ofcCd 管理事務所番号
   * @property itmkndCd 観測所種別コード
   * @property obsCd 観測所コード
   * @property cctvCd 河川カメラID
   * @property appTime 対象日時
   */
  async getSelectedTm(payload) {
    if (payload.itmkndCd == 1) {
      // 観測所種別コード=1(雨量)
      const param =
        payload.ofcCd +
        "/" +
        payload.itmkndCd +
        "/" +
        payload.obsCd +
        "/" +
        Util.formatDate(payload.appTime, timeFormat) +
        "/" +
        payload.isCurrent;
      logger.debug("api getSelectedTm-rain(" + param + ")");
      return Repository.get(`${resource}tmObsRain/` + param);
    } else if (payload.itmkndCd == 2) {
      // 観測所種別コード = 2(流域平均雨量)
      const param =
        payload.ofcCd +
        "/" +
        payload.itmkndCd +
        "/" +
        payload.obsCd +
        "/" +
        Util.formatDate(payload.appTime, timeFormat) +
        "/" +
        payload.isCurrent;
      logger.debug("api getSelectedTm-bsn(" + param + ")");
      return Repository.get(`${resource}tmObsBsn/` + param);
    } else if (payload.itmkndCd == 3) {
      // 観測所種別コード = 3(積雪)
      const param =
        payload.ofcCd +
        "/" +
        payload.itmkndCd +
        "/" +
        payload.obsCd +
        "/" +
        Util.formatDate(payload.appTime, timeFormat) +
        "/" +
        payload.isCurrent;
      logger.debug("api getSelectedTm-snow(" + param + ")");
      return Repository.get(`${resource}tmObsSnow/` + param);
    } else if (payload.itmkndCd == 4) {
      // 観測所種別コード = 4(水位)
      const param =
        payload.ofcCd +
        "/" +
        payload.itmkndCd +
        "/" +
        payload.obsCd +
        "/" +
        Util.formatDate(payload.appTime, timeFormat) +
        "/" +
        payload.isCurrent;
      logger.debug("api getSelectedTm-stage(" + param + ")");
      return Repository.get(`${resource}tmObsStage/` + param);
    } else if (payload.itmkndCd == 6) {
      // 観測所種別コード = 6(水質)
      const param =
        payload.ofcCd +
        "/" +
        payload.itmkndCd +
        "/" +
        payload.obsCd +
        "/" +
        Util.formatDate(payload.appTime, timeFormat) +
        "/" +
        payload.isCurrent;
      logger.debug("api getSelectedTm-wtr-qual(" + param + ")");
      return Repository.get(`${resource}tmObsWtrQual/` + param);
    } else if (payload.itmkndCd == 7) {
      // 観測所種別コード = 7(ダム諸量)
      const param =
        payload.ofcCd +
        "/" +
        payload.itmkndCd +
        "/" +
        payload.obsCd +
        "/" +
        Util.formatDate(payload.appTime, timeFormat) +
        "/" +
        payload.isCurrent;
      logger.debug("api getSelectedTm-dam(" + param + ")");
      return Repository.get(`${resource}tmObsDam/` + param);
    } else if (payload.itmkndCd == 12) {
      // 観測所種別コード = 12(海岸)
      const param =
        payload.ofcCd +
        "/" +
        payload.itmkndCd +
        "/" +
        payload.obsCd +
        "/" +
        Util.formatDate(payload.appTime, timeFormat) +
        "/" +
        payload.isCurrent;
      logger.debug("api getSelectedTm-coast(" + param + ")");
      return Repository.get(`${resource}tmObsCoast/` + param);
    } else if (payload.itmkndCd == 20 || payload.itmkndCd == 21) {
      // 観測所種別コード = 20(レーダ流域平均雨量(大流域)) or 21(レーダ流域平均雨量(小流域))
      const param =
        payload.ofcCd +
        "/" +
        payload.itmkndCd +
        "/" +
        payload.obsCd +
        "/" +
        Util.formatDate(payload.appTime, timeFormat) +
        "/" +
        payload.isCurrent;
      logger.debug("api getSelectedTm-rd(" + param + ")");
      return Repository.get(`${resource}tmObsRdBsn/` + param);
    } else if (payload.itmkndCd == 100) {
      // 観測所種別コード = 100(河川カメラ)
      const param = payload.ofcCd + "/" + payload.cctvCd;
      logger.debug("api getSelectedTm-cctv(" + param + ")");
      return Repository.get(`${resource}tmObsCctv/` + param);
    } else if (payload.itmkndCd == 200) {
      // 観測所種別コード = 200(簡易カメラ)
      const param = payload.ofcCd + "/" + payload.scamCd;
      let obsScamArry;
      logger.debug("api getSelectedTm-scam(" + param + ")");
      /* #74 簡易カメラの表示 ローカルファイルを参照しないよう一時的コメント化および代替処理の追加 */
      /*
      await axios
      .get("http://localhost:8081/data/" + payload.scamCd + ".json")
      .then(response => {
        obsScamArry = {
          data:{
            tmObsResult:{
              scamDetailInfo:{
                bnkSct: "",
                scamAdr: "",
                scamCd: response.data.features[0].properties.id,
                scamNm: response.data.features[0].properties.cams_name,
                cctvSct: 0,
                dspFlg: 0,
                dspOrd: 0,
                itmkndCd: 0,
                jrsCd: 0,
                jrsNm: "",
                lat: response.data.features[0].geometry.coordinates[0],
                latestUrl: response.data.features[0].properties.current_url,
                lon: response.data.features[0].geometry.coordinates[1],
                obsAdr: "",
                obsCd: 0,
                obsFcd: "",
                obsKana: "",
                obsNm: "",
                obsNmS: "",
                obsSadr: "",
                obsSct: 0,
                obsSkana: "",
                ofcCd: 0,
                ofcNm: "",
                prefCd: 0,
                qwtrObsCd: "",
                rsysCd: response.data.features[0].properties.rsys_cd,
                rsysKana: "",
                rsysNm: response.data.features[0].properties.rsys_name,
                rvrCd: response.data.features[0].properties.rvr_cd,
                rvrKana: "",
                rvrMouthDst: 0,
                rvrNm: response.data.features[0].properties.rvr_name,
                twnCd: response.data.features[0].properties.id,
                type: 2,
                usualUrl: response.data.features[0].properties.normally_url
              }
            }
          }
        };
      })
      .catch(error => {
        console.log('簡易カメラjsonファイル取得エラー', error);
      })
      .finally()
      */
      obsScamArry = {
        data: {
          tmObsResult: {
            scamDetailInfo: {
              bnkSct: "",
              scamAdr: "",
              scamCd: 11010001,
              scamNm: "埼玉県草加市栄町　谷古宇水位観測所",
              cctvSct: 0,
              dspFlg: 0,
              dspOrd: 0,
              itmkndCd: 0,
              jrsCd: 0,
              jrsNm: "",
              lat: 35.8382194,
              latestUrl:
                "http://www.ktr.mlit.go.jp/edogawa/saigai/live/camera/img/p_yako.jpg",
              lon: 139.8065889,
              obsAdr: "",
              obsCd: 0,
              obsFcd: "",
              obsKana: "",
              obsNm: "",
              obsNmS: "",
              obsSadr: "",
              obsSct: 0,
              obsSkana: "",
              ofcCd: 0,
              ofcNm: "",
              prefCd: 0,
              qwtrObsCd: "",
              rsysCd: 83028000,
              rsysKana: "とねがわ",
              rsysNm: "利根川",
              rvrCd: 83028098,
              rvrKana: "あやせがわ",
              rvrMouthDst: 0,
              rvrNm: "綾瀬川",
              twnCd: 11010001,
              type: 2,
              usualUrl:
                "http://www.ktr.mlit.go.jp/ktr_content/content/000651040.jpg",
            },
          },
        },
      };

      return obsScamArry;
    }
  },
  /**
   * 地点登録情報の登録
   * @param {*} regPointNo 登録地点番号
   * @param {*} token トークン
   * @param {*} twnCd 市町村コード
   * @param {*} obsList 観測所リスト
   * @param {*} swobslist 危機管理型水位計リスト
   */
  async registPoint(regPointNo, token, twnCd, obsList, swobslist) {
    if (!obsList || obsList.length === 0) {
      obsList = "none";
    }
    if (!swobslist || swobslist.length === 0) {
      swobslist = "none";
    }
    const param =
      regPointNo + "/" + token + "/" + twnCd + "/" + obsList + "/" + swobslist;
    return Repository.get(`${resource}registPoint/` + param);
  },
  /**
   * 地点登録情報の通知変更
   * @param {*} regPointNo 登録地点番号
   * @param {*} token トークン
   * @param {*} obsList 観測所リスト
   * @param {*} swobslist 危機管理型水位計リスト
   */
  async changeNotice(regPointNo, token, obsList, swobslist) {
    if (!obsList || obsList.length === 0) {
      obsList = "none";
    }
    if (!swobslist || swobslist.length === 0) {
      swobslist = "none";
    }
    const param = regPointNo + "/" + token + "/" + obsList + "/" + swobslist;
    return Repository.get(`${resource}changeNotice/` + param);
  },
  /**
   * 地点登録情報の削除
   * @param {*} regPointNo 登録地点番号
   * @param {*} token トークン
   */
  async deletePoint(regPointNo, token) {
    const param = regPointNo + "/" + token;
    return Repository.get(`${resource}deletePoint/` + param);
  },
  /**
   * 過去画像パス情報 取得
   * @param {object} payload
   * @property itmkndCd 観測所種別コード
   * @property appTime 対象日時
   * @property cctvCd 河川カメラID
   * @property scamId 簡易カメラID
   */
  async getHistoryImagePaths(payload, itmkndCd, originProduction, historyCamUrl, testEnvironmentsIp) {
    
    if (itmkndCd == 4) {
      // 観測所種別コード = 4(水位)
      const path = payload;
      logger.debug("getHistoryImagePaths-stage(" + path + ")");
      if (location.origin === originProduction) {
        return jsonRepository.get(historyCamUrl + path);
      } else if(location.origin.includes('localhost')) {
        return jsonRepository.get(location.origin + `/kawabou/file/files/master/obs/cam/history/` + path);
      } else {
        // 試験環境用
        return jsonRepository.get(`http://` + testEnvironmentsIp + `/cam/history/` + path);
      }
    } else if (itmkndCd == 100) {
      // 観測所種別コード = 100(河川カメラ)
      const path = payload;
      logger.debug("getHistoryImagePaths-cctv(" + path + ")");
      if (location.origin === originProduction) {
        return jsonRepository.get(historyCamUrl + path);
      } else if(location.origin.includes('localhost')) {
        return jsonRepository.get(location.origin + `/kawabou/file/files/master/obs/cam/history/` + path);
      } else {
        // 試験環境用
        return jsonRepository.get(`http://` + testEnvironmentsIp + `/cam/history/` + path);
      }
    }
     else if (itmkndCd == 200) {
      // 観測所種別コード = 200(簡易カメラ)
      const path = payload;
      logger.debug("getHistoryImagePaths-scam(" + path + ")");
      if (location.origin === originProduction) {
        return jsonRepository.get(historyCamUrl + path);
      } else if(location.origin.includes('localhost')) {
        return jsonRepository.get(location.origin + `/kawabou/file/files/master/obs/cam/history/` + path);
      } else {
        // 試験環境用
        return jsonRepository.get(`http://` + testEnvironmentsIp + `/cam/history/` + path);
      }
    } else if (itmkndCd == 300) {
      // 観測所種別コード = 300(危機管理型水位計観測所河川カメラ)
      const path = payload;
      logger.debug("getHistoryImagePaths-swstg(" + path + ")");
      if (location.origin === originProduction) {
        return jsonRepository.get(historyCamUrl + path);
      } else if(location.origin.includes('localhost')) {
        return jsonRepository.get(location.origin + `/kawabou/file/files/master/obs/cam/history/` + path);
      } else {
        // 試験環境用
        return jsonRepository.get(`http://` + testEnvironmentsIp + `/cam/history/` + path);
      }
    }
  }
};
